import { useEffect, useState } from "react";
import { format$Price, formatPrice } from "utils/helpers/functions/formatPrice";

const _null = []
const _db = [10,6,3,2,12,9,0,12,1,8,10];

const WidgetHistoryNumber = ({aHistory, variant='primary', infoText='', iconJsx, invertPositive = false, priceMode = false}) => {

    const [ stateHistory, setStateHistory ] = useState(null);
     
    useEffect(()=>{
        // setStateHistory(_db)
        
    },[]) 

    useEffect(()=>{
        if (!aHistory) return;
        const _aHistory = [];
        for (let i=11; i>=0; i--) 
            _aHistory.push(aHistory?.[i]?.value || 0)
        setStateHistory(_aHistory)
    },[aHistory])

    const proc = (stateHistory?.[11] || 0) / (stateHistory?.[10]||1) * 100;
    
    
    return (
        <div className="col-lg-6 col-xxl-6">
        <div className="card WidgetHistoryNumber">
            <div className="card-body">
            <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                    <div className={`avtar avtar-s bg-light-${variant}`}>
                        {iconJsx}   
                    </div>
                </div>
                <div className="flex-grow-1 ms-3">
                <h6 className="mb-0">{infoText}</h6>
                </div>
                <div className="flex-shrink-0 ms-3">
                    
                </div>
            </div>
            <div className="bg-body p-3 mt-3 rounded">
                <div className="mt-3 row align-items-center">
                <div className="col-7 d-flex h-100 ">
                    {stateHistory && stateHistory.map((proc, index)=>{
                        const max = Math.max(...stateHistory);
                        const curr = Math.round((proc/max)*100);
                        return (
                            <div key={`${index}-${proc}`} 
                                title={`${aHistory[11-index]?.month} - ${priceMode ?  format$Price(proc) : proc}`}
                                className="prog-container">
                                    <div className={`bg-${variant} prog`}
                                        style={{height:`${curr}%`, width:'100%'}}></div>
                                </div>
                        )
                        
                    })}


                </div>
                <div className="col-5 text-end">
                    <h4 className="mb-0">{priceMode ?  format$Price(stateHistory?.[11]) : stateHistory?.[11]}</h4>
                    <p className="text-primary mb-0">
                    {stateHistory &&
                    (<span className="fs-12 fw-bold">{(proc).toFixed(2)}%</span>)}
                    
                    
                    </p>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>
    );
};



    export default WidgetHistoryNumber;